import React from 'react';
import SpecialGroupDetailContainer from '@src/containers/SpecialGroupDetail';

const SpecialGroupDetail = () => <SpecialGroupDetailContainer />;

export default SpecialGroupDetail;
